import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import moment from "moment";
import { formatDot } from "../../util/helperFunction";
import timLogo from "../../Assets/tim-lama.jpeg";

const PdfPurchaseOrder = ({
  data,
  listVendor,
  noPo,
  formId,
  dataPerusahaan,
}) => {
  const dataPdf = data ? data : [];

  const findketerangan = dataPdf?.find((item) => item?.formId === formId) || "";

  const keteranganPo = findketerangan?.keteranganPo || "";

  let dataIsPo = [];

  dataPdf &&
    dataPdf.forEach((element) => {
      if (element.noPo === noPo) {
        dataIsPo.push(element);
      }
    });

  const result = listVendor?.find(
    (item) => item?.id === dataIsPo[0]?.vendorId.id
  );

  const formatRupiah = (value) => {
    if (!value) return "0,00";

    return Number(value).toLocaleString("id-ID", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const subTotal = (dataIsPo || []).reduce((a, b) => {
    return a + (b.jumlah || 0) * (b.price || 0);
  }, 0);

  const discount = (dataIsPo || []).reduce((a, b) => {
    return a + (b.discount * (b.price * b.jumlah)) / 100;
  }, 0);

  const checkDiscount =
    discount > 0
      ? discount
      : dataIsPo[0]?.overallDiscount > 0
      ? dataIsPo[0]?.overallDiscount
      : 0;

  const netto = subTotal - checkDiscount;

  const tax = dataIsPo[0]?.checklistPpn
    ? ((subTotal - checkDiscount) * 11) / 100
    : 0;

  const grandTotal = netto + tax;

  const styles = StyleSheet.create({
    page: {
      padding: 16,
      fontSize: 9,
      fontFamily: "Helvetica",
    },

    rowBetween: {
      flexDirection: "row",
      justifyContent: "space-between",
    },

    row: {
      flexDirection: "row",
    },

    borderTop: {
      borderTop: "1px solid black",
    },

    borderBottom: {
      borderBottom: "1px solid black",
    },

    logo: {
      width: 38,
      height: 38,
      marginRight: 8,
    },

    companyWrapper: {
      flexDirection: "row",
      width: "100%",
    },
    companyName: {
      fontSize: 15,
      fontWeight: "bold",
    },

    companyDesc: {
      fontSize: 9,
      marginTop: 2,
    },

    companyAddress: {
      fontSize: 8,
      marginTop: 6,
    },

    title: {
      textAlign: "center",
      fontSize: 12,
      fontWeight: "bold",
      textDecoration: "underline",
      marginTop: 6,
      marginBottom: 8,
    },

    infoSection: {
      flexDirection: "row",
      justifyContent: "space-between",
      marginBottom: 14,
    },

    infoLeft: {
      width: "67%",
    },

    infoRight: {
      width: "28%",
    },

    infoRow: {
      flexDirection: "row",
      marginBottom: 4,
    },

    infoLabel: {
      width: 120,
      fontSize: 9,
    },

    infoColon: {
      width: 10,
    },

    infoValue: {
      flex: 1,
      fontSize: 9,
    },

    tableHeader: {
      flexDirection: "row",
      borderTop: "1px solid black",
      borderBottom: "1px solid black",
      paddingVertical: 4,
    },

    tableRow: {
      flexDirection: "row",
      paddingVertical: 4,
    },

    colNo: {
      width: "5%",
      fontSize: 8,
      textAlign: "center",
    },

    colDescTitle: {
      width: "40%",
      fontSize: 8,
      paddingHorizontal: 4,
      textAlign: "center",
    },
    colDesc: {
      width: "40%",
      fontSize: 8,
      paddingHorizontal: 4,
    },

    colQty: {
      width: "11%",
      fontSize: 8,
      textAlign: "right",
      paddingRight: 4,
    },

    colDisc: {
      width: "12%",
      fontSize: 8,
      paddingHorizontal: 4,
      textAlign: "right",
    },

    colPrice: {
      width: "16%",
      fontSize: 8,
      textAlign: "right",
      paddingRight: 4,
    },

    colTotal: {
      width: "16%",
      fontSize: 8,
      textAlign: "right",
      paddingRight: 4,
    },

    footerWrapper: {
      marginTop: 18,
      paddingTop: 12,
      flexDirection: "row",
      justifyContent: "space-between",
      borderTop: "1px solid #d9d9d9",
    },

    footerLeft: {
      width: "52%",
    },

    footerRight: {
      width: "32%",
    },

    totalRow: {
      flexDirection: "row",
      marginBottom: 4,
      gap: 12,
    },

    totalLabel: {
      width: "40%",
      fontSize: 9,
    },

    totalRp: {
      width: "10%",
      fontSize: 9,
      textAlign: "center",
    },

    totalValue: {
      width: "60%",
      fontSize: 9,
      textAlign: "right",
    },

    signWrapper: {
      flexDirection: "row",
      justifyContent: "space-between",
      marginTop: 30,
    },

    signBox: {
      width: "30%",
      alignItems: "center",
    },

    signTitle: {
      fontSize: 9,
      marginBottom: 70,
    },

    signNameVendor: {
      fontSize: 9,
      minWidth: 80,
      color: "white",
      fontWeight: "bold",
      borderBottom: "1px solid black",
    },

    signName: {
      fontSize: 9,
      fontWeight: "bold",
      borderBottom: "1px solid black",
    },

    signPosition: {
      fontSize: 9,
      marginTop: 2,
    },

    note: {
      marginTop: 4,
      fontSize: 7,
    },

    bottomInfo: {
      borderTop: "1px solid black",
      marginTop: 10,
      paddingTop: 10,
    },

    bottomRow: {
      flexDirection: "row",
      width: "100%",
      marginBottom: 2,
    },

    bottomLabel: {
      width: 75,
      fontSize: 8,
    },

    bottomColon: {
      width: 8,
      fontSize: 8,
    },

    bottomValue: {
      width: "82%",
      fontSize: 8,
    },
  });

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* HEADER */}
        <View
          style={[styles.rowBetween, styles.borderBottom, { paddingBottom: 8 }]}
        >
          <View style={styles.companyWrapper}>
            {/* LOGO */}
            <View
              style={{
                width: "8%",
                marginRight: 4,
              }}
            >
              <Image src={timLogo} style={styles.logo} />
            </View>

            {/* CONTENT */}
            <View
              style={{
                width: "92%",
              }}
            >
              <Text style={styles.companyName}>PT. TENAR INTI MANDIRI</Text>

              <Text style={styles.companyDesc}>Plastic Injection Industry</Text>

              <View style={{ marginTop: 4 }}>
                <View style={styles.bottomRow}>
                  <Text style={styles.bottomLabel}>Nama PKP.</Text>
                  <Text style={styles.bottomColon}>:</Text>

                  <Text style={styles.bottomValue}>PT. TENAR INTI MANDIRI</Text>
                </View>

                <View style={styles.bottomRow}>
                  <Text style={styles.bottomLabel}>N.P.W.P.</Text>
                  <Text style={styles.bottomColon}>:</Text>

                  <Text style={styles.bottomValue}>
                    {dataPerusahaan?.npwp || ""}
                  </Text>
                </View>

                <View style={styles.bottomRow}>
                  <Text style={styles.bottomLabel}>Alamat NPWP</Text>
                  <Text style={styles.bottomColon}>:</Text>

                  <Text style={styles.bottomValue}>
                    {dataPerusahaan?.alamatNpwp || ""}
                  </Text>
                </View>

                <View style={styles.bottomRow}>
                  <Text style={styles.bottomLabel}>Alamat Kirim</Text>
                  <Text style={styles.bottomColon}>:</Text>

                  <Text style={styles.bottomValue}>
                    {dataPerusahaan?.alamatKirim || ""}
                  </Text>
                </View>
                <View style={styles.bottomRow}>
                  <Text style={styles.bottomLabel}>Tlp / Fax / Email</Text>
                  <Text style={styles.bottomColon}>:</Text>

                  <Text style={styles.bottomValue}>
                    {dataPerusahaan?.tlp ? `${dataPerusahaan.tlp}` : ""}{" "}
                    {dataPerusahaan?.fax ? ` / ${dataPerusahaan.fax}` : ""}{" "}
                    {dataPerusahaan?.email ? ` / ${dataPerusahaan.email}` : ""}
                  </Text>
                </View>
              </View>
            </View>
          </View>
          <View style={{ marginRight: 8, width: "17%", textAlign: "center" }}>
            <Text
              style={{
                padding: "6px",
                border: "1px solid black",
                textAlign: "center",
              }}
            >
              Form-PUR-A6-R1
            </Text>
          </View>
        </View>

        {/* TITLE */}
        <Text style={styles.title}>PURCHASE ORDER</Text>

        {/* INFO */}
        <View style={styles.infoSection}>
          <View style={styles.infoLeft}>
            <View style={styles.infoRow}>
              <Text style={styles.infoLabel}>Nama Penyedia Eksternal</Text>
              <Text style={styles.infoColon}>:</Text>
              <Text style={styles.infoValue}>{result?.name || ""}</Text>
            </View>

            <View style={styles.infoRow}>
              <Text style={styles.infoLabel}>Alamat</Text>
              <Text style={styles.infoColon}>:</Text>
              <Text style={styles.infoValue}>{result?.alamat || ""}</Text>
            </View>

            <View style={styles.infoRow}>
              <Text style={styles.infoLabel}>NPWP</Text>
              <Text style={styles.infoColon}>:</Text>
              <Text style={styles.infoValue}>{result?.npwp || ""}</Text>
            </View>

            <View style={styles.infoRow}>
              <Text style={styles.infoLabel}>Telp. / Fax / Email</Text>
              <Text style={styles.infoColon}>:</Text>
              <Text style={styles.infoValue}>
                {result?.tlp || ""}
                {result?.fax ? ` / ${result?.fax}` : ""}
                {result?.email ? ` / ${result?.email}` : ""}
              </Text>
            </View>

            <View style={styles.infoRow}>
              <Text style={styles.infoLabel}>Attn</Text>
              <Text style={styles.infoColon}>:</Text>
              <Text style={styles.infoValue}>{result?.attn || ""}</Text>
            </View>
          </View>

          <View style={styles.infoRight}>
            <View style={styles.infoRow}>
              <Text style={[styles.infoLabel, { width: 80 }]}>Tanggal PO</Text>

              <Text style={styles.infoColon}>:</Text>

              <Text style={styles.infoValue}>
                {dataIsPo[0]?.datePo
                  ? moment(dataIsPo[0]?.datePo)
                      .utcOffset("+0700")
                      .format("DD/MM/YYYY")
                  : ""}
              </Text>
            </View>

            <View style={styles.infoRow}>
              <Text style={[styles.infoLabel, { width: 80 }]}>Nomor PO</Text>

              <Text style={styles.infoColon}>:</Text>

              <Text style={styles.infoValue}>{dataIsPo[0]?.noPo || ""}</Text>
            </View>
          </View>
        </View>

        {/* TABLE HEADER */}
        <View style={styles.tableHeader}>
          <Text style={styles.colNo}>NO</Text>
          <Text style={styles.colDescTitle}>DESCRIPTION</Text>
          <Text style={styles.colQty}>QUANTITY</Text>
          <Text style={styles.colPrice}>UNIT PRICE</Text>
          <Text style={styles.colDisc}>DISCOUNT</Text>
          <Text style={styles.colTotal}>TOTAL PRICE</Text>
        </View>

        {/* TABLE BODY */}
        {dataIsPo &&
          dataIsPo.map((item, index) => {
            const qtyItem = item?.jumlah || 0;
            const priceItem = item?.price || 0;
            const disc = item?.discount || 0;
            const totalPricePerItem = qtyItem * priceItem;

            return (
              <>
                <View style={styles.tableRow} key={index}>
                  <Text style={styles.colNo}>{index + 1}</Text>

                  <View style={styles.colDesc}>
                    <Text>{item.item}</Text>
                    {item?.subTitle?.map((ele, idx) => (
                      <Text
                        key={idx}
                        style={{
                          fontSize: 8,
                          marginTop: 2,
                          marginLeft: 6,
                          color: "#878781",
                        }}
                      >
                        {ele.desc}
                      </Text>
                    ))}
                  </View>

                  <View style={styles.colQty}>
                    <Text>
                      {formatDot(item.jumlah)} {item.satuan}
                    </Text>

                    {item?.subTitle?.map((ele, idx) => (
                      <Text
                        key={idx}
                        style={{
                          fontSize: 8,
                          marginTop: 2,
                          color: "#878781",
                        }}
                      >
                        {ele.qty}
                      </Text>
                    ))}
                  </View>

                  <Text style={styles.colPrice}>
                    {item?.curr || "IDR"} {formatRupiah(item.price)}
                  </Text>
                  <Text style={styles.colDisc}>{item.discount} %</Text>

                  <Text style={styles.colTotal}>
                    {dataIsPo[0]?.curr ? `${dataIsPo[0]?.curr}` : "IDR"}{" "}
                    {formatRupiah(totalPricePerItem)}
                  </Text>
                </View>
              </>
            );
          })}

        {/* FOOTER */}
        <View style={styles.footerWrapper}>
          <View style={styles.footerLeft}>
            <View style={styles.infoRow}>
              <Text style={styles.infoLabel}>Delivery Time</Text>
              <Text style={styles.infoColon}>:</Text>
              <Text style={styles.infoValue}>
                {dataIsPo[0]?.deliveryTime || ""}
              </Text>
            </View>

            <View style={styles.infoRow}>
              <Text style={styles.infoLabel}>Term Of Payment</Text>
              <Text style={styles.infoColon}>:</Text>
              <Text style={styles.infoValue}>
                {dataIsPo[0]?.termOfPayment || ""}
              </Text>
            </View>
          </View>

          <View style={styles.footerRight}>
            <View style={styles.totalRow}>
              <Text style={styles.totalLabel}>SubTotal</Text>
              <Text style={styles.totalRp}>
                {dataIsPo[0]?.curr ? `${dataIsPo[0]?.curr}` : "IDR"}
              </Text>
              <Text style={styles.totalValue}>{formatRupiah(subTotal)}</Text>
            </View>

            <View style={styles.totalRow}>
              <Text style={styles.totalLabel}>Discount</Text>
              <Text style={styles.totalRp}>
                {dataIsPo[0]?.curr ? `${dataIsPo[0]?.curr}` : "IDR"}
              </Text>
              <Text style={styles.totalValue}>
                {checkDiscount ? formatRupiah(checkDiscount) : "-"}
              </Text>
            </View>

            <View style={styles.totalRow}>
              <Text style={styles.totalLabel}>Netto</Text>
              <Text style={styles.totalRp}>
                {dataIsPo[0]?.curr ? `${dataIsPo[0]?.curr}` : "IDR"}
              </Text>
              <Text style={styles.totalValue}>{formatRupiah(netto)}</Text>
            </View>

            <View style={styles.totalRow}>
              <Text style={styles.totalLabel}>Tax</Text>
              <Text style={styles.totalRp}>
                {dataIsPo[0]?.curr ? `${dataIsPo[0]?.curr}` : "IDR"}
              </Text>
              <Text style={styles.totalValue}>{formatRupiah(tax)}</Text>
            </View>

            <View style={styles.totalRow}>
              <Text
                style={[
                  styles.totalLabel,
                  { fontWeight: "bold", fontSize: 11 },
                ]}
              >
                Total
              </Text>

              <Text
                style={[styles.totalRp, { fontWeight: "bold", fontSize: 11 }]}
              >
                {dataIsPo[0]?.curr ? `${dataIsPo[0]?.curr}` : "IDR"}
              </Text>

              <Text
                style={[
                  styles.totalValue,
                  { fontWeight: "bold", fontSize: 11 },
                ]}
              >
                {formatRupiah(grandTotal)}
              </Text>
            </View>
          </View>
        </View>

        {/* SIGNATURE */}
        <View style={styles.signWrapper}>
          <View style={styles.signBox}>
            <Text style={styles.signTitle}>Penyedia Eksternal</Text>

            <Text style={styles.signNameVendor}>a</Text>
          </View>

          <View style={styles.signBox}>
            <Text style={styles.signTitle}>Disetujui</Text>

            <Text style={styles.signName}>
              {dataPerusahaan?.direktur || ""}
            </Text>

            <Text style={styles.signPosition}>Direktur</Text>
          </View>

          <View style={styles.signBox}>
            <Text style={styles.signTitle}>Dibuat</Text>

            <Text style={styles.signName}>{dataPerusahaan?.kabag || ""}</Text>

            <Text style={styles.signPosition}>Ka. Bag. Pembelian</Text>
          </View>
        </View>

        {/* NOTE */}
        <Text
          style={{
            fontWeight: "bold",
            textDecoration: "underline",
            marginTop: 10,
          }}
        >
          NOTES :
        </Text>
        <Text style={styles.note}>
          * PO Yang Telah diterima dan ditandatangani, mohon segera di fax
          kembali kepada kami.
        </Text>
        <Text style={styles.note}>{keteranganPo}</Text>
      </Page>
    </Document>
  );
};

export default PdfPurchaseOrder;
